import create from 'zustand'
import store from '../../../store'
import throwReactQueryError from '../utils/throwReactQueryError'

const E404 = ({ error, requestParams }) => {
  const { getState } = create(store)

  const isStaging = getState().target === 'staging'

  if (isStaging) {
    console.log(`URL not found: ${requestParams.url}`)
  }

  return throwReactQueryError(error)
}

export default E404
